/**
 * Returns the terminal canonical category segment for compact list/table views.
 */
export function formatCanonicalCategoryLeaf(
  value: string | null | undefined,
): string {
  if (value == null || value === "") return "";

  const parts = value
    .trim()
    .split(/[.>]+/)
    .map((part) => part.trim())
    .filter(Boolean);

  return parts.at(-1) ?? value.trim();
}
